import { Box, Button, Flex, Loading, Text, createColumnHelper } from 'ui'
import { useMemo } from 'react'
import { usePulseContext } from '../../context/PulseProvider'
import { useTopComplaints } from 'queries/pulse/useTopComplaints'
import { TopComplaints as TopComplaintsType } from 'api/pulse/topComplaints'
import { InfiniteTable } from '../InfiniteTable'
import { formatNumber } from 'lib/string'
import { startCase } from 'lodash'
import { useTopComplaintsDownloadCsv } from 'queries/pulse/useTopComplaintsDownloadCsv'

const columnHelper = createColumnHelper<TopComplaintsType[0]>()

const columns = [
  columnHelper.accessor('complaint', {
    header: 'Complaint',
    cell: (info) => <Text>{startCase(info.getValue())}</Text>,
  }),
  columnHelper.accessor('num_complaints', {
    header: 'Count',
    cell: (info) => <Text>{formatNumber(info.getValue() as number)}</Text>,
  }),
]

export function TopComplaints() {
  const {
    state: { filters },
  } = usePulseContext()

  const filtersWithPagination = useMemo(() => {
    return {
      ...filters,
      page: 0,
      pageSize: 50,
    }
  }, [filters])

  const { data, isLoading, isFetching, fetchNextPage, hasNextPage } =
    useTopComplaints(filtersWithPagination)

  const { mutateAsync: downloadCsv, isPending: isDownloadingCsv } =
    useTopComplaintsDownloadCsv(filters)

  const flatData = useMemo(() => {
    return data?.pages.flatMap((page) => page) ?? []
  }, [data])

  return (
    <Box flex={1}>
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        gap={3}
        mb={3}
      >
        <Box>
          <Text fontSize={3} fontWeight="500">
            Top Complaints
          </Text>
          <Text fontSize={2} color="lightText">
            Top complaints of Managers to Workers
          </Text>
        </Box>
        <Button
          variant="secondary"
          onClick={() => downloadCsv()}
          loading={isDownloadingCsv}
        >
          CSV
        </Button>
      </Flex>
      {isLoading ? (
        <Box p={3}>
          <Loading />
        </Box>
      ) : (
        <InfiniteTable
          data={flatData}
          columns={columns}
          isFetching={isFetching}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          height="400px"
        />
      )}
    </Box>
  )
}
